import type { TFunction } from 'i18next';
import type { WeightDiffDetailRow } from '../../types/snapshot.types';

export type AuditPositionStatusBadge = {
  label: string;
  color: 'positive' | 'negative';
};

export const resolveAuditPositionStatusBadge = (
  row: WeightDiffDetailRow,
  t: TFunction,
  isCashEventRebalance: boolean,
): AuditPositionStatusBadge | undefined => {
  if (row.currentCents === 0 && row.proposedCents > 0) {
    return {
      label: t('bulkRebalance:drawer.newPosition'),
      color: 'positive',
    };
  }

  if (row.deltaCents >= 0) {
    return undefined;
  }

  const runTimeCurrentCents = row.runTimeCurrentCents ?? row.currentCents;
  const runTimeProposedEnd = Math.max(0, runTimeCurrentCents + row.deltaCents);
  const isFullExit = runTimeProposedEnd === 0;

  if (isFullExit) {
    return {
      label: isCashEventRebalance
        ? t('bulkRebalance:drawer.sellToCashPosition')
        : t('bulkRebalance:drawer.exitPosition'),
      color: 'negative',
    };
  }

  return {
    label: t('bulkRebalance:drawer.sellToCashPosition'),
    color: 'negative',
  };
};
